import moment from 'moment';

export const groupByDateAndKey = (items, getKey, getDate, filterFn = () => true) => {
  const groupedData = {};

  items.filter(filterFn).forEach((item) => {
    const date = moment(getDate(item)).format('DD/MM/YYYY');
    const key = getKey(item) || 'Desconhecido';

    if (!groupedData[date]) groupedData[date] = {};
    if (!groupedData[date][key]) groupedData[date][key] = 0;

    groupedData[date][key] += 1;
  });

  return groupedData;
};

export const getSavedFilter = (key, defaultValue) => {
  const saved = sessionStorage.getItem('filtrosDashboard');
  return saved ? JSON.parse(saved)[key] || defaultValue : defaultValue;
};
